const Vue = require('vue');
const Hub = new Vue();

export default Hub;